import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  text-align: center;
  margin: 10px auto;

  @media (min-width: 992px) {
    max-width: 360px;
    margin: 15px auto;
  }
`;

export default Wrapper;
